module.exports = __webpack_public_path__ + "img/lock_icon.f108cd55.png";